export const GET_LANGUAGES = "GET_LANGUAGES";
export const ADD_LANGUAGE = "ADD_LANGUAGE";
export const UPDATE_LANGUAGE = "UPDATE_LANGUAGE";
export const TOGGLE_LANGUAGE_STATE = "TOGGLE_LANGUAGE_STATE";
export const DELETE_LANGUAGE = "DELETE_LANGUAGE";
export const GET_LANGUAGE_STATS_DATA = "GET_LANGUAGE_STATS_DATA";
